export default __webpack_public_path__ + "images/398ec1c880cbce19577789410bed9bc0.svg";